/* Zoo Snoods — Buy 2 Get 1 Free bundle UI.
   One set of bundle rules shared by the cart drawer tracker (snippets/zs-bundle-tracker.liquid)
   and the homepage bundle bar (sections/zs-bundle-bar.liquid).
   Cart data comes from snippets/zs-bundle-data.liquid: embedded in the drawer HTML on every Ella drawer refresh,
   in the bar section on page load, and from /cart?view=zs_bundle otherwise.
   The theme never applies the discount; it shows the math and reads what Shopify has applied. */
(function () {
  'use strict';

  var BUNDLE = 3;
  var CHEVRON = '<svg width="16" height="10" viewBox="0 0 16 10" fill="none" aria-hidden="true" focusable="false"><path d="M1.5 1.5L8 8L14.5 1.5" stroke="#1f2523" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function cfg() { return window.zsBundleConfig || {}; }
  function T(key) { var s = cfg().strings || {}; return s[key] || ''; }

  function fill(str, vars) {
    return String(str || '').replace(/\[(\w+)\]/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(vars, k) ? vars[k] : m;
    });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    var out = null;
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        out = window.Shopify.formatMoney(cents, cfg().moneyFormat || window.money_format);
      }
    } catch (e) { out = null; }
    if (!out) out = '$' + (cents / 100).toFixed(2);
    return String(out).replace(/<[^>]*>/g, '');
  }

  function initial(size) { return String(size || '').trim().charAt(0).toUpperCase(); }

  /* ---------- bundle model ---------- */

  // Builds rows from cart data. Units are counted (qty 2 = two snoods), oldest first.
  // Free units: Shopify's discount allocations when present, otherwise the cheapest floor(n/3)
  // (ties: the most recently added unit is free).
  function model(data) {
    var items = (data && data.items ? data.items.slice() : []).reverse();
    var units = [];
    var allocated = false;
    items.forEach(function (it) {
      if (!it.eligible) return;
      if (it.free_qty > 0) allocated = true;
      for (var q = 0; q < it.quantity; q++) {
        units.push({
          u: units.length, key: it.key, qty: it.quantity, title: it.title, short: it.short || it.title,
          size: it.size, price: it.price, image: it.image,
          allocFree: q >= it.quantity - (it.free_qty || 0)
        });
      }
    });

    var n = units.length;
    var freeIds = {};
    if (allocated) {
      units.forEach(function (x) { if (x.allocFree) freeIds[x.u] = true; });
    } else {
      units.slice().sort(function (a, b) { return a.price - b.price || b.u - a.u; })
        .slice(0, Math.floor(n / BUNDLE))
        .forEach(function (x) { freeIds[x.u] = true; });
    }
    var free = units.filter(function (x) { return freeIds[x.u]; }).sort(function (a, b) { return a.price - b.price || b.u - a.u; });
    var paid = units.filter(function (x) { return !freeIds[x.u]; });
    var fc = Math.min(free.length, Math.floor(paid.length / 2));
    var mod = n % BUNDLE;

    var saved = 0;
    if (allocated) {
      items.forEach(function (it) { if (it.eligible) saved += it.alloc || 0; });
    } else {
      free.slice(0, fc).forEach(function (x) { saved += x.price; });
    }

    var rows = [];
    for (var r = 0; r < fc; r++) {
      rows.push({ done: true, index: r, units: [paid[2 * r], paid[2 * r + 1], free[r]], free: free[r] });
    }
    var rest = paid.slice(2 * fc).concat(free.slice(fc));
    rows.push({ done: false, index: fc, units: [rest[0] || null, rest[1] || null, null] });

    // Cart total: exact when Shopify has applied the discount, otherwise the expected total.
    var total = allocated ? data.total : Math.max(0, (data.original_total || 0) - saved);

    return { n: n, fc: fc, mod: mod, left: BUNDLE - mod, saved: saved, total: total, rows: rows, units: units };
  }

  /* ---------- squares ---------- */

  function square(unit, isFree, pos, opts) {
    var cls = 'zs-sq' + (unit ? (isFree ? ' zs-sq--free' : ' zs-sq--paid') : (pos === 2 ? ' zs-sq--empty-free' : ' zs-sq--empty'));
    var html = '<div class="' + cls + '">';
    if (!unit) {
      if (pos === 2) {
        html += '<span class="zs-sq__free">' + esc(opts.freeLabel || 'FREE') + '</span>';
        if (opts.freeSub) html += '<span class="zs-sq__free-sub">' + esc(opts.freeSub) + '</span>';
      } else {
        html += '<span class="zs-sq__num">' + (pos + 1) + '</span>';
      }
    } else {
      var label = unit.title + (unit.size ? ', ' + unit.size : '');
      html += unit.image ? '<img src="' + esc(unit.image) + '" alt="' + esc(label) + '" loading="lazy" width="120" height="120">' : '';
      if (opts.pills) {
        var pill = isFree ? (opts.freeLabel || 'FREE') : (opts.longPill ? initial(unit.size) + ' · ' + money(unit.price) : initial(unit.size));
        if (pill) html += '<span class="zs-sq__pill' + (isFree ? ' zs-sq__pill--free' : '') + '">' + esc(pill) + '</span>';
      }
      if (opts.remove) {
        html += '<button type="button" class="zs-sq__remove" data-zs-remove="' + esc(unit.key) + '" aria-label="' + esc(fill(opts.removeLabel || 'Remove [name]', { name: label })) + '">×</button>';
      }
    }
    return html + '</div>';
  }

  /* ---------- cart drawer tracker ---------- */

  function foldState(fc) {
    var st = null;
    try { st = JSON.parse(window.sessionStorage.getItem('zs-bundle-folds') || 'null'); } catch (e) { st = null; }
    if (!st || st.bundles !== fc) st = { bundles: fc, over: {} };
    return st;
  }
  function saveFolds(st) {
    try { window.sessionStorage.setItem('zs-bundle-folds', JSON.stringify(st)); } catch (e) { /* private mode */ }
  }

  function renderTracker(el) {
    var dataEl = el.querySelector('[data-zs-bundle-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var m = model(data);
    var R = m.rows.length;
    var st = foldState(m.fc);
    var sqOpts = { pills: true, freeLabel: T('free'), freeSub: T('freeSub') };

    var chip = el.querySelector('[data-zs-chip]');
    if (chip) {
      chip.hidden = m.fc < 1;
      chip.textContent = fill(m.fc === 1 ? T('chipOne') : T('chipMany'), { free: m.fc });
    }

    var html = '';
    m.rows.forEach(function (row, idx) {
      var label, sub;
      if (row.done) {
        label = fill(T('labelDone'), { k: row.index + 1 });
        sub = fill(T('subDone'), { name: row.free.short, price: money(row.free.price) });
      } else {
        label = m.n === 0 ? T('labelStart') : fill(T('labelProgress'), { k: m.fc + 1 });
        sub = m.n === 0 ? T('subEmpty') : m.mod === 0 ? T('subZero') : m.mod === 1 ? T('subOne') : T('subTwo');
      }
      var folded = row.done && (Object.prototype.hasOwnProperty.call(st.over, row.index) ? st.over[row.index] : idx < R - 2);

      if (folded) {
        var aria = fill(T('showLabel'), { label: fill(T('labelProgress'), { k: row.index + 1 }) });
        html += '<button type="button" class="zs-trow zs-trow--folded" data-zs-toggle="' + row.index + '" aria-expanded="false" aria-label="' + esc(aria) + '">' +
          '<span class="zs-trow__thumbs">' + row.units.map(function (u, j) {
            return '<img src="' + esc(u.image) + '" alt="" width="52" height="52"' + (j === 2 ? ' class="is-free"' : '') + '>';
          }).join('') + '</span>' +
          '<span class="zs-trow__label">' + esc(label) + '</span>' +
          '<span class="zs-chev" aria-hidden="true">' + CHEVRON + '</span></button>';
      } else {
        html += '<div class="zs-trow">' +
          '<div class="zs-trow__squares">' + row.units.map(function (u, j) { return square(u, row.done && j === 2, j, sqOpts); }).join('') + '</div>' +
          '<div class="zs-trow__text"><div class="zs-trow__head"><span class="zs-trow__label">' + esc(label) + '</span>' +
          (row.done && R > 2 ? '<button type="button" class="zs-chev zs-chev--up" data-zs-toggle="' + row.index + '" aria-expanded="true" aria-label="' + esc(T('hideLabel')) + '">' + CHEVRON + '</button>' : '') +
          '</div><div class="zs-trow__sub">' + esc(sub) + '</div></div></div>';
      }
    });
    el.querySelector('[data-zs-rows]').innerHTML = html;

    el.querySelector('[data-zs-fill]').style.width = (m.mod / BUNDLE * 100) + '%';
    var vars = { left: m.left, saved: money(m.saved), next: m.fc + 1 };
    el.querySelector('[data-zs-status]').textContent = m.n === 0 ? T('statusEmpty') : m.fc > 0 ? fill(T('statusSaving'), vars) : fill(T('statusStart'), vars);

    if (!el.__zsBound) {
      el.__zsBound = true;
      el.addEventListener('click', function (e) {
        var t = e.target.closest('[data-zs-toggle]');
        if (!t) return;
        var d = JSON.parse(el.querySelector('[data-zs-bundle-data]').textContent);
        var mm = model(d);
        var s = foldState(mm.fc);
        var i = Number(t.getAttribute('data-zs-toggle'));
        var wasFolded = t.getAttribute('aria-expanded') === 'false';
        s.over[i] = !wasFolded;
        saveFolds(s);
        renderTracker(el);
        var again = el.querySelector('[data-zs-toggle="' + i + '"]');
        if (again) again.focus({ preventScroll: true });
      });
    }
    return data;
  }

  /* ---------- homepage bundle bar ---------- */

  function Bar(root) {
    this.root = root;
    this.c = JSON.parse(root.querySelector('[data-zs-bar-config]').textContent);
    this.busy = false;
    var self = this;

    this.slot = root.querySelector('[data-zs-bar-slot]');
    this.bar = root.querySelector('[data-zs-bar]');
    var dataEl = root.querySelector('[data-zs-bundle-data]');
    try { this.data = JSON.parse(dataEl.textContent); } catch (e) { this.data = { items: [] }; }

    root.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-zs-remove]');
      if (rm) { e.preventDefault(); self.remove(rm.getAttribute('data-zs-remove')); }
    });

    this.render();
    this.badgesInit();
    if (this.c.sticky) this.stickyInit();
  }

  Bar.prototype.render = function () {
    var m = model(this.data);
    var c = this.c;
    var row = m.mod === 0 && m.fc > 0 ? m.rows[m.fc - 1] : m.rows[m.rows.length - 1];
    var desktop = window.matchMedia('(min-width: 750px)').matches;
    var opts = desktop
      ? { pills: true, longPill: true, remove: !this.busy, freeLabel: c.free, freeSub: c.freeSub, removeLabel: c.removeLabel }
      : { pills: false, remove: false, freeLabel: c.free };
    this.bar.querySelector('[data-zs-squares]').innerHTML = row.units.map(function (u, j) {
      return square(u, row.done && j === 2, j, opts);
    }).join('');

    var vars = { n: m.n, left: m.left, free: m.fc, saved: money(m.saved) };
    var status;
    if (m.n === 0) status = c.statusEmpty;
    else if (m.mod !== 0) status = fill(m.fc >= 1 ? c.statusPartialMore : c.statusPartial, vars);
    else if (m.fc === 1) status = fill(c.statusComplete, vars);
    else status = fill(c.statusMany, vars);
    this.bar.querySelectorAll('[data-zs-status]').forEach(function (s) { s.textContent = status; });
    var chip = this.bar.querySelector('[data-zs-chip]');
    if (chip) {
      chip.hidden = m.fc < 1;
      chip.textContent = fill(m.fc === 1 ? c.chipOne : c.chipMany, { free: m.fc });
    }
    // Two-tone tracker (homepage v5): the bundle shown and how full it is. A just-completed bundle shows as full.
    var bnum = this.bar.querySelector('[data-zs-bnum]');
    if (bnum && c.bundleLabel != null) bnum.textContent = fill(c.bundleLabel, { n: row.index + 1 });
    var count = this.bar.querySelector('[data-zs-count]');
    if (count && c.countLabel != null) {
      var filled = row.done ? BUNDLE : row.units.filter(Boolean).length;
      count.textContent = fill(c.countLabel, { filled: filled });
    }
    var pct = (m.mod === 0 && m.n > 0 ? 100 : m.mod / BUNDLE * 100) + '%';
    this.bar.querySelectorAll('[data-zs-fill]').forEach(function (f) { f.style.width = pct; });
    this.root.classList.toggle('is-busy', this.busy);
    this.m = m;
    this.badges();
  };

  Bar.prototype.setData = function (data) {
    if (!data) return;
    this.data = data;
    this.render();
    if (this.pinned) this.syncPin();
  };

  Bar.prototype.remove = function (key) {
    if (this.busy) return;
    var line = null;
    (this.data.items || []).forEach(function (it) { if (it.key === key) line = it; });
    if (!line) return;
    var self = this;
    this.busy = true;
    this.render();
    fetch(cfg().cartChangeUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: line.quantity - 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return refreshCart(cart); })
      .catch(function () {})
      .then(function () { self.busy = false; return loadData(); })
      .then(function (d) { self.setData(d); });
  };

  /* "In cart" badges on the product cards of the section right below the bar (Hot Products). */
  Bar.prototype.badgesInit = function () {
    if (!this.c.showBadges) return;
    var sec = this.root.closest('.shopify-section');
    this.target = sec && sec.nextElementSibling;
    if (!this.target) return;
    var self = this;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () { pending = false; self.badges(); });
    }).observe(this.target, { childList: true, subtree: true });
    this.badges();
  };

  Bar.prototype.badges = function () {
    if (!this.target || !this.m) return;
    var counts = {};
    (this.data.items || []).forEach(function (it) { counts[it.product_id] = (counts[it.product_id] || 0) + it.quantity; });
    var c = this.c;
    this.target.querySelectorAll('[data-product-id]').forEach(function (card) {
      var host = card.querySelector('.card-product') || card;
      var n = counts[card.getAttribute('data-product-id')] || 0;
      var b = host.querySelector(':scope > .zs-incart');
      if (!n) { if (b) b.remove(); return; }
      if (!b) {
        if (window.getComputedStyle(host).position === 'static') host.style.position = 'relative';
        b = document.createElement('span');
        b.className = 'zs-incart';
        host.appendChild(b);
      }
      var text = n > 1 ? fill(c.badgeMany, { count: n }) : c.badgeOne;
      if (b.textContent !== text) b.textContent = text;
    });
  };

  /* Pin the bar under the header while the section below it (Hot Products) is on screen. */
  Bar.prototype.stickyInit = function () {
    var self = this;
    var sec = this.root.closest('.shopify-section');
    this.stopEl = sec && sec.nextElementSibling;
    var raf = null;
    function onScroll() {
      if (raf) return;
      raf = window.requestAnimationFrame(function () { raf = null; self.syncPin(); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { self.render(); self.syncPin(); });
    this.syncPin();
  };

  function headerBottom() {
    var bottom = 0;
    document.querySelectorAll('.shopify-section-group-header-group, sticky-header, .header-sticky').forEach(function (h) {
      var pos = window.getComputedStyle(h).position;
      if (pos !== 'sticky' && pos !== 'fixed') return;
      var b = h.getBoundingClientRect();
      if (b.top <= 1 && b.bottom > bottom && b.height < window.innerHeight / 2) bottom = b.bottom;
    });
    return Math.max(0, Math.round(bottom));
  }

  Bar.prototype.syncPin = function () {
    var slot = this.slot.getBoundingClientRect();
    var top = headerBottom();
    var h = this.bar.offsetHeight;
    var stop = this.stopEl ? this.stopEl.getBoundingClientRect().bottom : Infinity;
    var pin = slot.top < top && stop > top + h;
    if (pin) {
      this.slot.style.height = h + 'px';
      this.bar.classList.add('is-pinned');
      this.bar.style.top = top + 'px';
      this.bar.style.left = slot.left + 'px';
      this.bar.style.width = slot.width + 'px';
    } else if (this.pinned) {
      this.slot.style.height = '';
      this.bar.classList.remove('is-pinned');
      this.bar.style.top = this.bar.style.left = this.bar.style.width = '';
    }
    this.pinned = pin;
  };

  /* ---------- cart plumbing ---------- */

  function drawerWrapper() {
    return document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
  }

  // No "Accept: application/json" header here: Shopify then ignores ?view= and returns plain cart JSON
  // (without the eligibility flags), which made every snood look ineligible.
  function loadData() {
    return fetch((cfg().cartUrl || '/cart') + '?view=zs_bundle', { cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var d = JSON.parse(t);
        return d && Array.isArray(d.items) && (!d.items.length || 'eligible' in d.items[0]) ? d : null;
      })
      .catch(function () { return null; });
  }

  // Refresh Ella's drawer contents and cart count (mirrors halo.updateSidebarCart, which isn't global).
  function refreshCart(cart) {
    if (cart && typeof cart.item_count === 'number') {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    }
    var wrap = drawerWrapper();
    if (!wrap) return Promise.resolve();
    return fetch((cfg().cartUrl || '/cart') + '?view=ajax_side_cart', { cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (window.jQuery) window.jQuery(wrap).html(html);
        else wrap.innerHTML = html;
        document.querySelectorAll('[data-free-shipping-wrapper]').forEach(function (w) {
          w.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
  }

  var bars = [];

  function renderDrawer() {
    var data = null;
    document.querySelectorAll('[data-zs-tracker]').forEach(function (el) { data = renderTracker(el) || data; });
    return data;
  }

  function onCartChanged() {
    var data = renderDrawer();
    if (!bars.length) return;
    (data ? Promise.resolve(data) : loadData()).then(function (d) {
      bars.forEach(function (b) { b.setData(d); });
    });
  }

  function init() {
    document.querySelectorAll('[data-zs-bundle-bar]').forEach(function (root) {
      if (root.__zsBar) return;
      root.__zsBar = new Bar(root);
      bars.push(root.__zsBar);
    });
    renderDrawer();

    // Ella replaces the drawer contents after every cart change; re-render from the fresh embedded data.
    var wrap = drawerWrapper();
    if (wrap && !wrap.__zsObserved) {
      wrap.__zsObserved = true;
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        Promise.resolve().then(function () { pending = false; onCartChanged(); });
      }).observe(wrap, { childList: true });
    }
  }

  if (!window.__zsBundleWired) {
    window.__zsBundleWired = true;
    document.addEventListener('cart-update', function () { if (!drawerWrapper()) onCartChanged(); });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) loadData().then(function (d) { bars.forEach(function (b) { b.setData(d); }); });
    });
    document.addEventListener('shopify:section:load', init);
  }

  window.ZsBundle = { model: model, init: init, refresh: onCartChanged };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
